import React from 'react';
import '../../../../../../Assets/styles/LandingStyles/LandingComponentsStyles/BeginnersGuideStyles/SudokuBasicsStyles/Congratulations.css';
import CtaLogo from '../../../../../../Assets/images/Logo/ctalogo.png';
import AppStoreButton from '../../Buttons/AppleStoreButton';
import GooglePlayButton from '../../Buttons/GoogleStoreButton';

interface CongratulationsProps {
    onSwitchTab: (tab: 'origins' | 'basics' | 'rules') => void;
}

const Congratulations: React.FC<CongratulationsProps> = ({ onSwitchTab }) => (
    <div className="congratulations-container">
        {/* Header Section */}
        <div className="header-section">
            <h1 className="title">Congratulations!</h1>
            <p className="subtitle">
                You&#39;ve successfully completed the Sudoku basics tutorial! Your dedication and effort have paid off, and you&#39;re now equipped with the essential skills to tackle Sudoku puzzles with confidence.
            </p>
        </div>

        {/* Next Steps Section */}
        <div className="next-steps-section">
            <div className="next-steps-content">
                <h2 className="next-steps-title">Next Steps</h2>
                <p className="next-steps-text">
                    Now it&#39;s time to put your skills to the test! Download the Sudoku game today and immerse yourself in a variety of puzzles. Whether you prefer a quick singles game or want to engage in some friendly competition, you can choose to play in <strong>single mode</strong> or <strong>vs mode</strong> against an opponent.
                </p>
            </div>

            <div className="cta-column">
                <h3 className="cta-header">Up for a game? <strong className="cta-highlight">Download Now!</strong></h3>
                <div className="platform-logo-wrapper">
                    <img
                        src={CtaLogo}
                        alt="Sudoku Game Logo"
                        className="platform-logo"
                    />
                </div>
                <div className="download-buttons-container">
                    <div className="store-button-wrapper">
                        <GooglePlayButton />
                    </div>
                    <div className="store-button-wrapper">
                        <AppStoreButton />
                    </div>
                </div>
            </div>
        </div>

        {/* Game Rules Section */}
        <div className="game-rules-section">
            <h2 className="game-rules-title">Master the Game Rules</h2>
            <p className="game-rules-text">
                Before you jump in, be sure to check out{' '}
                <a
                    href="#"
                    className="rules-link"
                    onClick={(e) => {
                        e.preventDefault();
                        onSwitchTab('rules');
                    }}
                >
                    Sudoku VS: Game Rules
                </a>.
                <strong>Understanding the rules and point system can give you an advantage when playing against opponents.</strong> This knowledge will enhance your experience and help you strategize effectively!
            </p>
        </div>
    </div>
);

export default Congratulations;
